import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalServiceStatusComponent } from './modal-service-status.component';
import { IconModule } from '../icon/icon.module';
import { UtilitiesModule } from '../utilities/utilities.module';



@NgModule({
  declarations: [ModalServiceStatusComponent],
  imports: [
    CommonModule,
    UtilitiesModule,
    IconModule
  ],
  exports: [ModalServiceStatusComponent]
})
export class ModalServiceStatusModule { }
